import _ from 'lodash';

const initialState = {
  projects: {},
  attachments: {},
  isFetching: false,
  boardCopyExternalID: '',
  boardCopyError: null
};

export default function entities (state = initialState, action) {
  if (action.request) {
    return _.merge({}, state, { isFetching: true });
  }

  if ('PROJECT_ATTACHMENTS_UPDATE_SUCCESS' === action.type) {
    return _.assign({}, state,
      { attachments: _.get(action, ['response', 'entities', 'attachments'], []) },
      { isFetching: false });
  }

  if (action.response && action.response.entities) {
    return _.merge({}, state, action.response.entities, { isFetching: false });
  }

  if ('PROJECT_BOARD_DELETE_SUCCESS' === action.type) {
    const { externalID } = action;
    const updatedProjects = _.omit(state.projects, externalID);
    return _.set(state, 'projects', updatedProjects);
  }

  return state;
}
